module.exports = __webpack_public_path__ + "static/media/Ryerson.b74bc1cb.svg";